


























































































import usersApp from '@/store/types/usersApp';

import { Component, Ref, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { UsersAppParams } from '@/store/interfaces/usersApp';
import emailVerification from '@/components/Reusable/badgeRedGreen.vue';
import { VuexFunction } from '@/ts/axios';
import { tPropsToSearch, tTableColumns, tTeipTableRef } from 'teip-components';
import { responseDataPagination } from '@/store/interfaces/json-api/generics';
import ActionConfirm from '@/components/modals/actionConfirm.vue';
import DatesFormat from '@/util/classes/datesFormat';
import { http } from '@/util/HTTP';
import { TeipNotifications } from '@/util/teipNotifications';
const formatDate = new DatesFormat();

@Component({
  name: 'UserAccount',
  components: {
    emailVerification,
    ActionConfirm,
  },
})
class UserAccount extends Vue {
  @Ref('accountTable') readonly accountTable!: tTeipTableRef;

  propsToSearch: tPropsToSearch = ['email_cont'];
  tableColumns: tTableColumns = [
    {
      prop: 'name',
      label: 'Usuario',
      minWidth: 250,
      formatter: (user: UsersAppParams): string => {
        return `${user.profile.first_name} ${user.profile.last_name}`;
      },
    },
    {
      prop: 'profile.phone_number',
      label: 'Celular',
      minWidth: 250,
      sortable: true,
    },
    {
      prop: 'email',
      label: 'Correo',
      minWidth: 250,
      sortable: true,
      slotName: 'email',
    },
    {
      prop: 'banned',
      label: 'Bloqueado',
      minWidth: 250,
      sortable: true,
      slotName: 'banned',
    },
    {
      prop: 'statistics.success_transactions_number',
      label: 'Transacciones completadas',
      minWidth: 275,
      sortable: true,
      slotName: 'success_transactions_number',
    },
    {
      prop: 'statistics.risk_transactions_number',
      label: 'Transacciones con issues',
      minWidth: 250,
      sortable: true,
      slotName: 'risk_transactions_number',
    },
    {
      prop: 'statistics.transactions_number',
      label: 'Total transacciones',
      minWidth: 250,
      sortable: true,
      slotName: 'transactions_number',
    },
    {
      prop: 'statistics.last_success_transaction_at',
      label: 'Fecha última transacción',
      minWidth: 250,
      formatter: (row: UsersAppParams): string => {
        return `${formatDate.formatDateTime(row.created_at)}`;
      },
    }
  ];

  confirm = false;

  rowSelected: UsersAppParams = {
    confirmed_email: false,
    created_at: '',
    email: '',
    handle: '',
    id: '',
    banned: false,
    profile: {
      avatar_url: null,
      birthdate: '',
      first_name: '',
      gender: 'F',
      id: '',
      last_name: '',
      phone_number: '',
    },
    statistics: {
      failure_transactions_number: 0,
      first_transaction_at: null,
      last_failure_transaction_at: null,
      last_risk_transaction_at: null,
      last_success_transaction_at: null,
      last_transaction_at: null,
      risk_transactions_number: 0,
      success_transactions_number: 0,
      transactions_number: 0,
    },
  };

  profile(): void {
    this.setSingleUser(this.rowSelected);
    this.$router.push({
      path: `/accounts/${this.rowSelected.id}/`,
    });
  }

  configuration(): void {
    this.setSingleUser(this.rowSelected);
    this.$router.push({
      path: `/accounts/${this.rowSelected.id}/configurations`,
    });
  }

  rowSelect(row: UsersAppParams): void {
    this.rowSelected = row;
  }

  confirmBan(): void {
    this.confirm = true;
  }

  async ban(): Promise<void> {
    const notification = new TeipNotifications();
    await http.put(`backoffice/customers/${this.rowSelected.id}/ban`);
    notification.success('Bloqueado', 'Usuario bloqueado satisfactoriamente');
    this.confirm = false;
    this.accountTable.fetchData();
  }

  @Action(`usersApp/${usersApp.actions.USERS_LIST}`) usersList!: VuexFunction;
  @Mutation(`usersApp/${usersApp.mutations.SET_SINGLE_USER}`)
  setSingleUser!: VuexFunction;

  @Getter(`usersApp/${usersApp.getters.GET_USERS}`)
  getUsersList!: responseDataPagination<UsersAppParams>;
}
export default UserAccount;
